import Button from 'components/Button/index'
import Select from 'components/Form/Select'
import TextArea from 'components/Form/TextArea'
import { FlexWrap } from 'components/UIComponents/FormStyles'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import AbsentIcon from 'components/icons/AbsentIcon'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import HoldtocompareIcon from 'components/icons/HoldtocompareIcon'
import SelectTickIcon from 'components/icons/SelectTickIcon'
import { bulkFileUploadStatus } from 'modules/InterviewerDashboard/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import {
  BoxFlex,
  CharactersText,
  CustomDiver,
  HeaderText,
  OuterDiv,
  OuterPadding,
  RowDiv,
  SkilsBox,
  SubTitleText,
} from './style'

const ActionDropdown = ({
  candidateDetails,
  singleRoleData,
  currentSelection,
  setCandidateDrawer,
  getCandidateList,
  canEditScore,
  parameterDetail,
  selectedTime,
}) => {
  const params = useParams()
  const [statusValue, setStatusValue] = useState(null)
  const dispatch = new useDispatch()
  const UserData = useSelector(state => state?.auth?.userData)
  const UserId = params?.userId ? params?.userId : UserData?._id
  const [feedbackList, setFeedbackList] = useState([])
  const [textFeedBack, setTextFeedBack] = useState('')
  const CheckList = [
    'MOVE_TO_NEXT_ROUND',
    'HOLD_TO_COMPARE',
    'ABSENT',
    'REJECT',
  ]

  const options2 = [
    {
      id: 2,
      name: (
        <div>
          <SelectTickIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>
            Move to next round
          </span>{' '}
        </div>
      ),
      value: 'MOVE_TO_NEXT_ROUND',
    },
    {
      id: 3,
      name: (
        <div>
          <HoldtocompareIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>
            Hold to compare
          </span>{' '}
        </div>
      ),
      value: 'HOLD_TO_COMPARE',
    },
    {
      id: 4,
      name: (
        <div>
          <AbsentIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>Absent</span>{' '}
        </div>
      ),
      value: 'ABSENT',
    },
    {
      id: 5,
      name: (
        <div>
          <RejectIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>Reject</span>{' '}
        </div>
      ),
      value: 'REJECT',
    },
  ]

  useEffect(() => {
    const Data =
      singleRoleData?.interviewParameters?.[currentSelection?.interviewRound]

    const outputArray = Data?.map(item => ({ name: item, value: '' }))
    setFeedbackList(outputArray)
  }, [currentSelection, parameterDetail])

  useEffect(() => {
    if (parameterDetail) {
      if (parameterDetail?.feedback) setTextFeedBack(parameterDetail?.feedback)
      if (CheckList?.includes(parameterDetail?.status)) {
        setStatusValue(parameterDetail?.status)
      }
      let input2 = parameterDetail?.parametersScore
      if (
        input2 !== null &&
        input2 !== undefined &&
        !(typeof input2 === 'object' && Object.keys(input2).length === 0)
      ) {
        let output = feedbackList?.map(item => {
          let updatedItem = { ...item } // Create a copy of the item
          if (input2[item.name] !== undefined) {
            updatedItem.value =
              typeof input2[item.name] === 'string'
                ? parseInt(input2[item.name])
                : input2[item.name]
          }
          return updatedItem
        })
        setFeedbackList(output)
      }
    }
  }, [parameterDetail])
  const statusChange = (value, option) => {
    setStatusValue(option?.option?.value)
  }

  const saveDetails = async () => {
    const outputObject = feedbackList?.reduce((acc, item) => {
      if (item.value !== 0 && item.value !== '') {
        acc[item.name] = item.value
      }
      return acc
    }, {})
    let payload = {
      file: false,
      status: statusValue,
      feedback: textFeedBack,
      interviewId: currentSelection?.interviewId,
      parametersScore: statusValue === 'ABSENT' ? {} : outputObject,
      startTime: selectedTime?.startDateWithTimestamp,
      stage: currentSelection?.interviewRound,
      studentIds: [
        {
          studentId: candidateDetails?.id,
        },
      ],
    }

    let response = await dispatch(
      bulkFileUploadStatus({
        interviewId: currentSelection?.interviewId,
        interviewerID: UserId,
        payload: payload,
      })
    )
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Status Updated Successfully!')
      setCandidateDrawer(false)
      getCandidateList()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const onClickField = (value, index, name) => {
    const outputArray = feedbackList.map(item => {
      if (item.name === index) {
        return { ...item, value: value }
      }
      return item
    })
    setFeedbackList(outputArray)
  }
  return (
    <OuterDiv>
      <HeaderText>Update Feedback</HeaderText>
      <CustomDiver />
      <OuterPadding>
        <SubTitleText>Status *</SubTitleText>

        <div>
          <Select
            showSearch={false}
            value={statusValue}
            placeholder={'Select Status'}
            valueParam="value"
            nameParam="name"
            OptionData={options2}
            onChange={statusChange}
          />
        </div>

        {statusValue != 'ABSENT' &&
          feedbackList?.map(list => (
            <>
              <SubTitleText>{list?.name?.toLowerCase()} </SubTitleText>

              <div>
                <BoxFlex left>
                  {[1, 2, 3, 4, 5]?.map((count, index) => {
                    return (
                      <SkilsBox
                        onClick={() => onClickField(count, list?.name, 'name')}
                        isSelected={list?.value === count}
                        key={index + count}
                      >
                        {count}
                      </SkilsBox>
                    )
                  })}
                </BoxFlex>
              </div>
            </>
          ))}
        <SubTitleText>Feedback</SubTitleText>
        <TextArea
          marginbottom={'2px'}
          value={textFeedBack}
          placeholder="Add FeedBack"
          maxLength={50}
          onChange={event => setTextFeedBack(event.target.value)}
        />
        <CharactersText>{textFeedBack.length} / 50 characters</CharactersText>
        <RowDiv></RowDiv>

        <FlexWrap gap="20px" right>
          <Button.Secondary
            text="Cancel"
            height="38px"
            onClick={() => setCandidateDrawer(false)}
          />
          <Button.Primary
            text={'Save'}
            //disabled={!statusValue }//canEditScore
            height="38px"
            onClick={saveDetails}
          />
        </FlexWrap>
      </OuterPadding>
    </OuterDiv>
  )
}

export default ActionDropdown
